export const accountTypes = [
  { key: "Checking Account", value: "checkingAccount" },
  { key: "Saving Account", value: "savingAccount" },
  { key: "Credit Card", value: "creditCard" },
  { key: "Cash", value: "cash" },
  { key: "Line of Credit", value: "lineOfCredit" },
  { key: "Investment", value: "investment" },
  { key: "Liability", value: "liability" },
];